/**
 * @fileoverview Candidacy Checklist Section Component
 * 
 * Displays the checklist/checks for a candidacy
 */

import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "components/ui/table";
import { Badge } from "components/ui/badge";
import { ListChecks } from "@phosphor-icons/react";
import { labelTranslator } from "components/candidates/types";

interface CandidacyChecklistSectionProps {
  entity: any;
}

export const CandidacyChecklistSection: React.FC<CandidacyChecklistSectionProps> = ({ entity }) => {
  if (!entity?.checklist || entity.checklist.length === 0) return null;

  return (
    <div className="bg-muted rounded-lg border border-neutral-primary/20 shadow-sm overflow-hidden">
      <div className="border-b border-neutral-primary/10 px-4 py-3">
        <div className="flex items-center gap-2">
          <ListChecks size={18} className="text-moss-primary" weight="duotone" />
          <h3 className="text-base font-semibold text-neutral-primary">Checks</h3>
        </div>
      </div>

      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Check</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Toelichting</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {entity.checklist.map((check: any, index: number) => {
              const labelInfo = labelTranslator(check.label);
              const isGood = (check.isChecked !== labelInfo.swapStatus);
              const statusText = isGood 
                ? (labelInfo.onGood || "Akkoord") 
                : (labelInfo.onBad || "Niet akkoord");

              return (
                <TableRow key={index}>
                  <TableCell>{labelInfo.label || check.label}</TableCell>
                  <TableCell>
                    <Badge 
                      variant={isGood ? "default" : "destructive"}
                      className={isGood 
                        ? 'bg-moss-primary/10 text-moss-primary border-moss-primary/30 hover:bg-moss-primary/20' 
                        : 'bg-brick-primary/10 text-brick-primary border-brick-primary/30 hover:bg-brick-primary/20'
                      }
                    >
                      {statusText}
                    </Badge>
                  </TableCell>
                  <TableCell>{check.explanation || '-'}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

